import DeleteIcon from '@mui/icons-material/Delete';
import {
    Button,
    Stack,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import RefundForm from 'components/routes/Pages/Refund/models/RefundForm';
import TextFieldControlled from 'components/shared/TextFieldControlled';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface PackageProps {
    onRemove: VoidFunction;
    index: number;
}

const Package: React.FC<PackageProps> = (props) => {
    const { t } = useTranslation('refund', { keyPrefix: 'PACKAGING_STEP' });

    const theme = useTheme();

    const small = useMediaQuery(theme.breakpoints.down('md'));

    const { index, onRemove } = props;

    const form = useFormContext<RefundForm>();

    return (
        <Stack gap={2}>
            <Stack flexDirection="row" alignItems="center" gap={2}>
                <Typography variant="subtitle2">
                    {index + 1}. {t('PACKAGE')}
                </Typography>

                <Button
                    color="error"
                    variant="outlined"
                    startIcon={<DeleteIcon />}
                    onClick={onRemove}
                >
                    <Typography variant="caption" textTransform="uppercase">
                        {t('REMOVE')}
                    </Typography>
                </Button>
            </Stack>

            <Stack gap={2}>
                <Typography variant="caption">{t('SIZE')}</Typography>

                <Stack gap={2} flexDirection={small ? 'column' : 'row'}>
                    <TextFieldControlled
                        control={form.control}
                        name={`package_parameters.${index}.width`}
                        label={t('WIDTH')}
                        type="number"
                    />
                    <TextFieldControlled
                        control={form.control}
                        name={`package_parameters.${index}.height`}
                        label={t('HEIGHT')}
                        type="number"
                    />
                    <TextFieldControlled
                        control={form.control}
                        name={`package_parameters.${index}.depth`}
                        label={t('DEPTH')}
                        type="number"
                    />
                </Stack>
            </Stack>

            <Stack gap={2}>
                <Typography variant="caption">{t('WEIGHT_TITLE')}</Typography>

                <Stack flexDirection="row" width="100%">
                    <TextFieldControlled
                        control={form.control}
                        name={`package_parameters.${index}.weight`}
                        label={t('WEIGHT')}
                        type="number"
                        sx={{ width: small ? '100%' : 'fit-content' }}
                    />
                </Stack>
            </Stack>

            <Stack gap={2} width="100%">
                <Typography variant="caption">
                    {t('REPLACEMENT_PALLET')}
                </Typography>

                <Stack
                    gap={2}
                    flexDirection={small ? 'column' : 'row'}
                    alignItems={small ? 'auto' : 'center'}
                    width="100%"
                    flex={1}
                >
                    <TextFieldControlled
                        control={form.control}
                        name={`package_parameters.${index}.pallet_number`}
                        type="number"
                        sx={{ width: small ? '100%' : 'fit-content' }}
                    />

                    <Typography variant="caption">
                        {t('PALLET_SIZE')}
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};

export default Package;
